import { useState } from "react";
import SectionTitle from "@/components/feature/SectionTitle";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
        <SectionTitle
          eyebrow="常见问题"
          title="关于吃瓜，你可能想问的"
          desc="如果这里没有覆盖你的疑问，欢迎到『联系我们』页面留言。"
        />

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.question}
                className={`overflow-hidden rounded-card border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-200" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                    {faq.question}
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}